import React from "react";

import { TabContent } from "../TabLayout";
import { courseSurveysApi } from "api/courseSurveysApi";
import { useToaster } from "utils";
import { CourseSurveysForm, CourseSurveysFormValues } from "./CourseSurveysForm";
import { CourseApi } from "api";
import { PaziaBox } from "components/atoms";

interface SurveysStepProps {
  course: CourseApi;
}
export const SurveysStep = ({ course }: SurveysStepProps): JSX.Element | null => {
  const { showError, showInfo } = useToaster();

  const onSubmit = async (data: CourseSurveysFormValues) => {
    try {
      await courseSurveysApi.save(course.data.id, data);
      showInfo("Ankiety zostały zapisane");
    } catch (e) {
      console.error(e);
      showError("Wystąpił błąd podczas zapisywania ankiet");
    }
  };
  return (
    <TabContent>
      <PaziaBox className="col-span-2 mb-4 flex justify-between">
        <div>
          <h2 className="text-xl font-bold text-slate-800 dark:text-slate-100">Ankiety</h2>
          <div className="mb-2 text-sm">Dodaj ankiety, które będą dostępne dla uczestników kursu</div>
        </div>
        <div></div>
      </PaziaBox>
      <PaziaBox className="flex flex-col gap-4 md:w-1/2">
        <CourseSurveysForm onSubmit={onSubmit} endSurvey={course.data.endSurvey} />
      </PaziaBox>
    </TabContent>
  );
};
